import { render, staticRenderFns } from "./RiceForm.vue?vue&type=template&id=1ddc1e7e&scoped=true"
import script from "./RiceForm.vue?vue&type=script&lang=js"
export * from "./RiceForm.vue?vue&type=script&lang=js"
import style0 from "./RiceForm.vue?vue&type=style&index=0&id=1ddc1e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddc1e7e",
  null
  
)

export default component.exports